<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">

                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Hiển thị trên cổng" :options="category_ENABLED"
                                :initialValue="modelSearch.enabled" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(v) => onSelectSearchChange(v, 'ENABLED')" />
                        </div>
                        <div class="col mb-3">
                            <TheInputText title="Tên trường" placeholder="Tìm theo tên trường"
                                :initialValue="modelSearch.tenTruong" v-model="modelSearch.tenTruong" :isRequire=false
                                @onChange="v => handlePageChange(1)" />
                        </div>
                        <div class="col mb-3">
                            <TheInputText title="Trường ID" placeholder="Tìm theo trường ID"
                                :initialValue="modelSearch.truongId" v-model="modelSearch.truongId" :isRequire=false
                                @onChange="v => handlePageChange(1)" />
                        </div>
                        <div class="col mb-3">
                            <TheInputText title="VEMIS ID" placeholder="Tìm theo VEMIS ID"
                                :initialValue="modelSearch.truongId" v-model="modelSearch.truongId" :isRequire=false
                                @onChange="v => handlePageChange(1)" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Phường/Xã" :options="category_PHUONGXA"
                                :initialValue="modelSearch.phuongXaId" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(v) => onSelectSearchChange(v, 'PHUONGXA')" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Mức trường chuẩn" :options="category_MUCTRUONGCHUANGD"
                                :initialValue="modelSearch.mucTruongchuanId" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(v) => onSelectSearchChange(v, 'MUCTRUONGCHUAN')" />
                        </div>

                        <div class="col mb-3">
                            <TheSelect title="Loại hình" :options="category_LOAIHINHTRUONGMAMNON"
                                :initialValue="modelSearch.loaihinhTruongMamnonId" :isMultiple="false"
                                :isAllowClear="true" :isRequire="false"
                                @onChange="(v) => onSelectSearchChange(v, 'LOAIHINHTRUONG')" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Quy mô trường chuẩn" :options="category_QUYMOTRUONGCHUANGD"
                                :initialValue="modelSearch.quymoTruongchuanId" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(v) => onSelectSearchChange(v, 'QUYMOTRUONGCHUAN')" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Phân loại" :options="category_sPHANLOAITRUONGMAMNON"
                                :initialValue="modelSearch.phanloaiTruongMamnonId" :isMultiple="false"
                                :isAllowClear="true" :isRequire="false"
                                @onChange="(v) => onSelectSearchChange(v, 'PHANLOAITRUONG')" />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;
                        <b v-if="sType_List == typeDataList.CURRENT_LIST.id">{{ $t('labels.currentList') }}</b>
                        <b v-if="sType_List == typeDataList.DELETED_LIST.id">{{ $t('labels.deletedList') }}</b>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" title="Xem bản đồ" @click="openMap()">
                            <i class="far fa-map" style="color: #28a745;"></i>
                        </button>
                        <button v-if="sType_List == typeDataList.DELETED_LIST.id" type="button" class="btn btn-tool"
                            :title="$t('buttons.swapCurrentList')" @click="changeCurrentTypeSearch()">
                            <i class="far fa-list-alt" style="color: #28a745;"></i>
                        </button>

                        <button v-if="sType_List == typeDataList.CURRENT_LIST.id" type="button" class="btn btn-tool"
                            :title="$t('buttons.swapDeletedList')" @click="changeCurrentTypeSearch()">
                            <i class="fas fa-list-alt" style="color: #df132e;"></i>
                        </button>
                        <button type="button" class="btn btn-tool" data-toggle="dropdown"
                            v-bind:title="$t('labels.cogs')">
                            <i class="fas fa-cogs"></i>
                            <div class="input-group-prepend">
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                    <a v-if="sType_List == typeDataList.DELETED_LIST.id"
                                        class="dropdown-item text-green" href="#"
                                        @click="confirmList(navigateCode.RESTORE)" :title="$t('buttons.restore')"><i
                                            class="fas fa-undo"></i>&nbsp;&nbsp;{{ $t('buttons.restore') }}</a>
                                    <div class="dropdown-divider"></div>
                                    <a v-if="sType_List == typeDataList.CURRENT_LIST.id" class="dropdown-item text-red"
                                        href="#" @click="confirmList(navigateCode.DELETE_TEMP)"
                                        :title="$t('buttons.delete')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('buttons.delete')
                                        }}</a>
                                    <a v-if="sType_List == typeDataList.DELETED_LIST.id" class="dropdown-item text-red"
                                        href="#" @click="confirmList(navigateCode.DELETE)"
                                        :title="$t('buttons.deleteReal')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('buttons.deleteReal')
                                        }}</a>
                                    <div class="dropdown-divider"></div>
                                    <a v-if="sType_List == typeDataList.CURRENT_LIST.id"
                                        class="dropdown-item text-green" href="#"
                                        @click="confirmList(navigateCode.ON_ENABLED)"
                                        :title="$t('buttons.onEnabled')"><i class="fas fa-toggle-on"></i>&nbsp;&nbsp;
                                        {{ $t('buttons.onEnabled') }}</a>
                                    <a v-if="sType_List == typeDataList.CURRENT_LIST.id" class="dropdown-item text-red"
                                        href="#" @click="confirmList(navigateCode.OFF_ENABLED)"
                                        :title="$t('buttons.offEnabled')"><i class="fas fa-toggle-off"></i>&nbsp;&nbsp;
                                        {{ $t('buttons.offEnabled') }}</a>
                                    <div class="dropdown-divider"></div>
                                </div>
                            </div>
                        </button>
                        <button type="button" class="btn btn-tool" @click="detail(null, navigateCode.CREATE)"
                            v-bind:title="$t('buttons.create')">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>
                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th class="col10"></th>
                                    <th class="col10">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                                @click="selectAllRows($event)">
                                            <label for="checkboxAll" class="custom-control-label"></label>
                                        </div>
                                    </th>
                                    <th class="col10 cursor" @click="handleSortChange('truongMamnonId')">
                                        ID
                                        <span v-if="sortBy == 'truongMamnonId'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col100 cursor" @click="handleSortChange('tenTruong')">
                                        Tên trường
                                        <span v-if="sortBy == 'tenTruong'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('tenPhuongXa')">
                                        Phường/Xã
                                        <span v-if="sortBy == 'tenPhuongXa'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('tenMucTruongchuan')">
                                        Mức trường chuẩn
                                        <span v-if="sortBy == 'tenMucTruongchuan'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('tenQuymoTruongchuan')">
                                        Quy mô trường chuẩn
                                        <span v-if="sortBy == 'tenQuymoTruongchuan'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('tenPhanloaiTruongchuan')">
                                        Phân loại
                                        <span v-if="sortBy == 'tenPhanloaiTruongchuan'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('congLap')">
                                        Công lập
                                        <span v-if="sortBy == 'congLap'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50">Trường ID</th>
                                    <th class="col50">Vemis ID</th>

                                    <th class="col10 cursor" @click="handleSortChange('stt')">
                                        STT
                                        <span v-if="sortBy == 'stt'" aria-hidden="true" class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50">Hiển thị trên cổng</th>
                                    <!-- <th class="col50">Đồng bộ từ IOC tỉnh</th> -->
                                    <th class="col50"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td></td>
                                    <td @click="selectRow(item.truongMamnonId)" style="cursor: pointer;"
                                        :title="$t('labels.selectItem')">
                                        <span v-if="(csList_Navigate.csList.includes(item.truongMamnonId))"
                                            aria-hidden="true" class="text-primary">&check;</span>
                                        <span v-else aria-hidden="true">&nbsp;</span>
                                    </td>
                                    <td>{{ item.truongMamnonId }}</td>
                                    <td>{{ item.tenTruong }}</td>
                                    <td>{{ item.tenPhuongXa }}</td>
                                    <td>{{ item.tenMucTruongchuan }}</td>
                                    <td>{{ item.tenQuymoTruongchuan }}</td>
                                    <td>{{ item.tenLoaihinhTruongMamnon }}</td>
                                    <td>{{ item.tenPhanloaiTruongMamnon }}</td>
                                    <td>{{ item.truongId }}</td>
                                    <td>{{ item.vemisId }}</td>
                                    <td>{{ item.stt }}</td>
                                    <td>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                :disabled="sType_List == typeDataList.DELETED_LIST.id"
                                                :id="'item' + item.truongMamnonId" v-model="item.enabledDisplay"
                                                v-on:click="openConfirmEnabledChange(item)">
                                            <label class="custom-control-label"
                                                :for="'item' + item.truongMamnonId"></label>
                                        </div>
                                    </td>
                                    <!-- <td>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                :disabled="sType_List == typeDataList.DELETED_LIST.id" :id="'itemIOC' + item.truongMamnonId"
                                                v-model="item.iocEnabledDisplay"
                                                v-on:click="openConfirmIOCEnabledChange(item)">
                                            <label class="custom-control-label"
                                                :for="'itemIOC' + item.truongMamnonId"></label>
                                        </div>
                                    </td> -->
                                    <td>
                                        <button v-if="sType_List == typeDataList.CURRENT_LIST.id" type="button"
                                            size="sm" class="btn btn-outline-primary btn-xs"
                                            v-on:click="openDetailMap(item.truongMamnonId)" title="Xem vị trí">
                                            <i class="fas fa-map-marked-alt" style="color: #28a745;"></i>
                                        </button>&nbsp;
                                        <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                            v-on:click="detail(item, navigateCode.DETAIL)" :title="$t('labels.detail')">
                                            <i class="fas fa-eye text-secondary"></i>
                                        </button>&nbsp;
                                        <span v-if="sType_List == typeDataList.CURRENT_LIST.id">
                                            <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                                v-on:click="detail(item, navigateCode.UPDATE)"
                                                :title="$t('labels.update')">
                                                <i class="fas fa-pencil-alt"></i>
                                            </button>&nbsp;
                                        </span>
                                        <button type="button" size="sm" class="btn btn-outline-danger btn-xs"
                                            v-on:click="detail(item, sType_List == typeDataList.DELETED_LIST.id ? navigateCode.DELETE : navigateCode.DELETE_TEMP)"
                                            :title="$t('labels.delete')">
                                            <i class="fas fa-trash-alt"></i>
                                        </button>&nbsp;

                                        <button v-if="sType_List == typeDataList.DELETED_LIST.id" type="button"
                                            size="sm" class="btn btn-outline-warning btn-xs"
                                            v-on:click="detail(item, navigateCode.RESTORE)"
                                            :title="$t('labels.restore')">
                                            <i class="fas fa-undo"></i>
                                        </button>&nbsp;
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <TheCRUDFrameModal ref="modalCRUDRef" @modalClosed="null" idModal="crudModal" dialogClass=" modal-80vw"
        :headerTitle="title" :displaySubmit="loadingSubmit" :onSubmit="onSubmit" :titleSubmit="title"
        :styleButton="styleButton">
        <div class="row">
            <div class="modal-box">
                <div class="header-box no-dropdown">
                    <div class="title-box"><i class="fas fa-caret-right"></i> <b>Thông tin trường:</b></div>
                </div>

                <div class="modal-box-content">
                    <div class="row">
                        <div class="col-md-6">
                            <TheInputText title="Tên trường" placeholder="Nhập tên trường"
                                :initialValue="model.tenTruong" v-model="model.tenTruong" :error="errors.tenTruong"
                                :isReadOnly="isReadOnly" :isRequire=true :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <!-- <div class="col-md-3">
                            <TheInputText title="Trường ID" placeholder="Nhập trường ID" :initialValue="model.truongId"
                                v-model="model.truongId" :error="errors.truongId" :isReadOnly="isReadOnly"
                                :isRequire=false :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="Vemis ID" placeholder="Nhập vemis ID" :initialValue="model.vemisId"
                                v-model="model.vemisId" :error="errors.vemisId" :isReadOnly="isReadOnly"
                                :isRequire=false :isMultipleLine="false" :key="tempKey" />
                        </div> -->
                        <div class="col-md-3">
                            <TheInputText title="STT" placeholder="Nhập STT" :initialValue="model.stt"
                                v-model="model.stt" :error="errors.stt" :isReadOnly="isReadOnly" :isRequire=true
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <div class="row">
                                <div class="form-group">
                                    <label>Hiển thị trên cổng</label>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="enabled-checkbox"
                                            v-model="model.enabledDisplay" :disabled="isReadOnly">
                                        <label class="custom-control-label" for="enabled-checkbox"></label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <TheSelect title="Mức trường chuẩn" :options="category_MUCTRUONGCHUANGD"
                                :initialValue="model.mucTruongchuanId" :error="errors.mucTruongchuanId"
                                :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                                @onChange="(e) => { model.mucTruongchuanId = e }" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheSelect title="Loại hình trường" :options="category_LOAIHINHTRUONGMAMNON"
                                :initialValue="model.loaihinhTruongMamnonId" :error="errors.loaihinhTruongMamnonId"
                                :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                                @onChange="(e) => { model.loaihinhTruongMamnonId = e }" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheSelect title="Quy mô" :options="category_QUYMOTRUONGCHUANGD"
                                :initialValue="model.quymoTruongchuanId" :error="errors.quymoTruongchuanId"
                                :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                                @onChange="(e) => onChangeEDIT_QuyMo(e)" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheSelect title="Phân loại trường" :options="category_cPHANLOAITRUONGMAMNON"
                                :initialValue="model.phanloaiTruongMamnonId" :error="errors.phanloaiTruongMamnonId"
                                :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                                @onChange="(e) => { model.phanloaiTruongMamnonId = e }" :key="tempKey" />
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-md-9">
                            <TheInputText title="Hiệu trưởng" placeholder="Nhập hiệu trưởng"
                                :initialValue="model.hieuTruong" v-model="model.hieuTruong" :error="errors.hieuTruong"
                                :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="Số điện thoại hiệu trưởng" placeholder="Nhập SĐT hiệu trưởng"
                                :initialValue="model.sdtHieuTruong" v-model="model.sdtHieuTruong"
                                :error="errors.sdtHieuTruong" :isReadOnly="isReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <TheYearPicker title="Năm công nhận" placeholder="Nhập năm công nhận"
                                :initialValue="model.namCongNhan" v-model="model.namCongNhan"
                                :error="errors.namCongNhan" :isReadOnly="isReadOnly" :isRequire="false" minYear="1975"
                                :maxYear="new Date().getFullYear().toString()" :key="tempKey"
                                @onChange="(e) => { model.namCongNhan = e }" />
                        </div>
                        <div class="col-md-4">
                            <TheYearPicker title="Năm sát nhập" placeholder="Nhập năm sát nhập"
                                :initialValue="model.namSatNhap" v-model="model.namSatNhap" :error="errors.namSatNhap"
                                :isReadOnly="isReadOnly" :isRequire="false" minYear="1975"
                                :maxYear="new Date().getFullYear().toString()" :key="tempKey"
                                @onChange="(e) => { model.namSatNhap = e }" />
                        </div>
                        <div class="col-md-4">
                            <TheYearPicker title="Năm thành lập" placeholder="Nhập năm thành lập"
                                :initialValue="model.namThanhLap" v-model="model.namThanhLap"
                                :error="errors.namThanhLap" :isReadOnly="isReadOnly" :isRequire="false" minYear="1975"
                                :maxYear="new Date().getFullYear().toString()" :key="tempKey"
                                @onChange="(e) => { model.namThanhLap = e }" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <TheSelect title="Phường xã" :options="category_PHUONGXA" :initialValue="model.phuongXaId"
                                :error="errors.phuongXaId" :isMultiple="false" :isReadOnly="isReadOnly"
                                :isAllowClear="true" :isRequire="true" @onChange="(e) => { model.phuongXaId = e }"
                                :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="GPS Long" placeholder="Nhập GPS Long" :initialValue="model.gpsLong"
                                v-model="model.gpsLong" :error="errors.gpsLong" :isReadOnly="isReadOnly"
                                :isRequire=false :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="GPS Lat" placeholder="Nhập GPS Lat" :initialValue="model.gpsLat"
                                v-model="model.gpsLat" :error="errors.gpsLat" :isReadOnly="isReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheGetLocationButton v-model:modelValueLat="model.gpsLat"
                                v-model:modelValueLong="model.gpsLong" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <TheInputText title="Ghi chú" placeholder="Nhập ghi chú" :initialValue="model.ghiChu"
                                v-model="model.ghiChu" :error="errors.ghiChu" :isReadOnly="isReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <TheInputText title="Giới thiệu" placeholder="Nhập giới thiệu"
                                :initialValue="model.gioiThieu" v-model="model.gioiThieu" :error="errors.gioiThieu"
                                :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="true" :isSummerNote="true"
                                :key="tempKey" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="modal-box">
                <div class="header-box">
                    <div class="title-box"><i class="fas fa-caret-right"></i> <b>Thông tin biến động: <span
                        v-if="oldValueKy && !isChangedValueKy" style="color: #2489e3;"> {{ oldValueKy }}</span></b>
                    </div>
                    <div class="title2-box ">
                        <TheSelect2 ref="" title="Năm" :options="category_cKY" :initialValue="model?.idKy"
                            :isMultiple="false" :isReadOnly="isReadOnly" heightSelect="calc(1.75rem + 4px)"
                            :isRequire="false" :isAllowClear="true" :key="tempKey"
                            @onChange="(v) => onChangeEdit_KY(v)" />
                    </div>
                </div>
                <div class="modal-box-content" v-if="model.idKy && model.phanloaiTruongMamnonId">
                    <!-- PHÒNG HỌC-->
                    <div class="row">
                        <div class="col-md-3">
                            <TheInputText title="Tổng số phòng học" placeholder="Nhập tổng số phòng học"
                                :initialValue="model.tongsoPhong" v-model="model.tongsoPhong"
                                :error="errors.tongsoPhong" :isReadOnly="isFluctuationsReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="Số phòng kiên cố" placeholder="Nhập phòng kiên cố"
                                :initialValue="model.phongKienco" v-model="model.phongKienco"
                                :error="errors.phongKienco" :isReadOnly="isFluctuationsReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="Số phòng bán kiên cố" placeholder="Nhập số phòng bán kiên cố"
                                :initialValue="model.phongBankienco" v-model="model.phongBankienco"
                                :error="errors.phongBankienco" :isReadOnly="isFluctuationsReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="Số phòng tạm" placeholder="Nhập số phòng tạm"
                                :initialValue="model.phongTam" v-model="model.phongTam" :error="errors.phongTam"
                                :isReadOnly="isFluctuationsReadOnly" :isRequire=false :isMultipleLine="false" :key="tempKey" />
                        </div>
                    </div>
                    <div class="divider"></div>
                    <!-- GIÁO VIÊN-->
                    <div class="row">
                        <div class="col-md-3">
                            <TheInputText title="Tổng số giáo viên" placeholder="Nhập tổng số giáo viên"
                                :initialValue="model.tongsoGiaovien" v-model="model.tongsoGiaovien"
                                :error="errors.tongsoGiaovien" :isReadOnly="isFluctuationsReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="Số giáo viên nữ" placeholder="Nhập số giáo viên nữ"
                                :initialValue="model.giaovienNu" v-model="model.giaovienNu" :error="errors.giaovienNu"
                                :isReadOnly="isFluctuationsReadOnly" :isRequire=false :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="Số giáo viên dân tộc thiểu số"
                                placeholder="Nhập số giáo viên dân tộc thiểu số"
                                :initialValue="model.giaovienDantocThieuso" v-model="model.giaovienDantocThieuso"
                                :error="errors.giaovienDantocThieuso" :isReadOnly="isFluctuationsReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="Số giáo viên đạt chuẩn" placeholder="Nhập số giáo viên đạt chuẩn"
                                :initialValue="model.giaovienDatchuan" v-model="model.giaovienDatchuan"
                                :error="errors.giaovienDatchuan" :isReadOnly="isFluctuationsReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                    </div>
                    <div class="divider"></div>
                    <!-- LỚP HỌC-->
                    <div class="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        <div class="col" v-if="[1, 4, 3, 6].includes(parseInt(model.phanloaiTruongMamnonId))">
                            <TheInputText title="Số nhóm trẻ" placeholder="Nhập số nhóm trẻ"
                                :initialValue="model.nhomTre" v-model="model.nhomTre" :error="errors.nhomTre"
                                :isReadOnly="isFluctuationsReadOnly" :isRequire=false :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col" v-if="[2, 5, 3, 6].includes(parseInt(model.phanloaiTruongMamnonId))">
                            <TheInputText title="Số lớp mẫu giáo" placeholder="Nhập số lớp mẫu giáo"
                                :initialValue="model.lopMauGiao" v-model="model.lopMauGiao" :error="errors.lopMauGiao"
                                :isReadOnly="isFluctuationsReadOnly" :isRequire=false :isMultipleLine="false" :key="tempKey" />
                        </div>

                    </div>

                    <div class="divider"></div>
                    <!-- HỌC SINH-->
                    <div class="row row-cols-2 row-cols-sm-3 row-cols-md-5 row-cols-lg-5 row-cols-xl-5">
                        <div class="col">
                            <TheInputText title="Tổng số HS" placeholder="Nhập tổng số HS"
                                :initialValue="model.tongsoHocsinh" v-model="model.tongsoHocsinh"
                                :error="errors.tongsoHocsinh" :isReadOnly="isFluctuationsReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col">
                            <TheInputText title="Tổng số HS định danh" placeholder="Nhập tổng số HS định danh"
                                :initialValue="model.tongsoHocsinhDadinhdanh" v-model="model.tongsoHocsinhDadinhdanh"
                                :error="errors.tongsoHocsinhDadinhdanh" :isReadOnly="isFluctuationsReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col">
                            <TheInputText title="Số HS nữ" placeholder="Nhập số HS nữ" :initialValue="model.hocsinhNu"
                                v-model="model.hocsinhNu" :error="errors.hocsinhNu" :isReadOnly="isFluctuationsReadOnly"
                                :isRequire=false :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col">
                            <TheInputText title="Số HS dân tộc thiểu số" placeholder="Nhập số HS dân tộc thiểu số"
                                :initialValue="model.hocsinhDantocThieuso" v-model="model.hocsinhDantocThieuso"
                                :error="errors.hocsinhDantocThieuso" :isReadOnly="isFluctuationsReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col">
                            <TheInputText title="Số HS khuyết tật" placeholder="Nhập số HS khuyết tật"
                                :initialValue="model.hocsinhKhuyettat" v-model="model.hocsinhKhuyettat"
                                :error="errors.hocsinhKhuyettat" :isReadOnly="isFluctuationsReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col">
                            <TheInputText title="Số HS suy dinh dưỡng" placeholder="Nhập số HS suy dinh dưỡng"
                                :initialValue="model.hocsinhSuydinhduong" v-model="model.hocsinhSuydinhduong"
                                :error="errors.hocsinhSuydinhduong" :isReadOnly="isFluctuationsReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4" v-if="[1, 3, 4, 6].includes(parseInt(model.phanloaiTruongMamnonId))">
                            <TheInputText title="Số HS 3 đến 12 tháng" placeholder="Nhập HS 3 đến 12 tháng"
                                :initialValue="model.hocsinh3den12M" v-model="model.hocsinh3den12M"
                                :error="errors.hocsinh3den12M" :isReadOnly="isFluctuationsReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-4" v-if="[1, 3, 4, 6].includes(parseInt(model.phanloaiTruongMamnonId))">
                            <TheInputText title="Số HS 13 đến 24 tháng" placeholder="Nhập HS 13 đến 24 tháng"
                                :initialValue="model.hocsinh13den24M" v-model="model.hocsinh13den24M"
                                :error="errors.hocsinh13den24M" :isReadOnly="isFluctuationsReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-4" v-if="[1, 3, 4, 6].includes(parseInt(model.phanloaiTruongMamnonId))">
                            <TheInputText title="Số HS 25 đến 36 tháng" placeholder="Nhập HS 25 đến 36 tháng"
                                :initialValue="model.hocsinh25den36M" v-model="model.hocsinh25den36M"
                                :error="errors.hocsinh25den36M" :isReadOnly="isFluctuationsReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>


                        <div class="col-md-4" v-if="[2, 3, 5, 6].includes(parseInt(model.phanloaiTruongMamnonId))">
                            <TheInputText title="Số HS 3 đến 4 tuổi" placeholder="Nhập HS 3 đến 4 tuổi"
                                :initialValue="model.hocsinh3den4Y" v-model="model.hocsinh3den4Y"
                                :error="errors.hocsinh3den4Y" :isReadOnly="isFluctuationsReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-4" v-if="[2, 3, 5, 6].includes(parseInt(model.phanloaiTruongMamnonId))">
                            <TheInputText title="Số HS 4 đến 5 tuổi" placeholder="Nhập HS 4 đến 5 tuổi"
                                :initialValue="model.hocsinh4den5Y" v-model="model.hocsinh4den5Y"
                                :error="errors.hocsinh4den5Y" :isReadOnly="isFluctuationsReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-4" v-if="[2, 3, 5, 6].includes(parseInt(model.phanloaiTruongMamnonId))">
                            <TheInputText title="Số HS 5 đến 6 tuổi" placeholder="Nhập HS 5 đến 6 tuổi"
                                :initialValue="model.hocsinh5den6Y" v-model="model.hocsinh5den6Y"
                                :error="errors.hocsinh5den6Y" :isReadOnly="isFluctuationsReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>


                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="modal-box">
                <div class="header-box no-dropdown">
                    <div class="title-box"><i class="fas fa-caret-right"></i> <b>Thông tin khác:</b></div>
                </div>

                <div class="modal-box-content">
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-md-5 row-cols-lg-5 row-cols-xl-5">
                        <div class="col">
                            <TheImageListPicker ref="filePickerDaiDien" title="&nbsp;&nbsp;Ảnh đại diện"
                                :initialValue="listFilesUpload.filesUpload" error="" :isReadOnly="isReadOnly"
                                :isRequire="false" :isMultiple="false"
                                @onChange="({ files, addedFiles, deletedFiles }) => { listFilesUpload.filesUpload = files }"
                                :acceptFile="acceptImageType" :key="tempKey" />
                        </div>
                        <div class="col">
                            <TheImageListPicker ref="filePickerHieuTruong" title="&nbsp;&nbsp;Ảnh hiệu trưởng"
                                :initialValue="listFilesUpload.imageHieuTruongUpload" error="" :isReadOnly="isReadOnly"
                                :isRequire="false" :isMultiple="false"
                                @onChange="({ files, addedFiles, deletedFiles }) => { listFilesUpload.imageHieuTruongUpload = files }"
                                :acceptFile="acceptImageType" :key="tempKey" />
                        </div>
                        <div class="col">
                            <TheImageListPicker ref="filePickerTapThe" title="&nbsp;&nbsp;Ảnh tập thể"
                                :initialValue="listFilesUpload.imageTapTheUpload" error="" :isReadOnly="isReadOnly"
                                :isRequire="false" :isMultiple="false"
                                @onChange="({ files, addedFiles, deletedFiles }) => { listFilesUpload.imageTapTheUpload = files }"
                                :acceptFile="acceptImageType" :key="tempKey" />
                        </div>
                        <div class="col">
                            <TheImageListPicker ref="filePickerCongTruong" title="&nbsp;&nbsp;Ảnh cổng trường"
                                :initialValue="listFilesUpload.imageCongTruongUpload" error="" :isReadOnly="isReadOnly"
                                :isRequire="false" :isMultiple="false"
                                @onChange="({ files, addedFiles, deletedFiles }) => { listFilesUpload.imageCongTruongUpload = files }"
                                :acceptFile="acceptImageType" :key="tempKey" />
                        </div>
                        <div class="col">
                            <TheImageListPicker ref="filePickerHoatDong" title="&nbsp;&nbsp;Ảnh hoạt động"
                                :initialValue="listFilesUpload.imageHoatDongUpload" error="" :isReadOnly="isReadOnly"
                                :isRequire="false" :isMultiple="false"
                                @onChange="({ files, addedFiles, deletedFiles }) => { listFilesUpload.imageHoatDongUpload = files }"
                                :acceptFile="acceptImageType" :key="tempKey" />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </TheCRUDFrameModal>

    <TheDetailFrameModal ref="modalDetailRef" @modalClosed="null" idModal="detailModal" dialogClass=" modal-80vw"
        :headerTitle="modelRec.tenTruong">
        <div class="row" v-if="modelRec && modelRec.hinhAnh">
            <div class="container mt-3 mb-3 p-1 d-flex justify-content-center">
                <div class=" image d-flex flex-column justify-content-center align-items-center">
                    <a :href="modelRec.linkHinhAnh" class="popup-link">
                        <img :src="modelRec.linkHinhAnh" class="image-thumb img-fluid" style="min-height: 150px;">
                    </a>
                </div>
            </div>
        </div>
        <div class="row" v-if="modelRec">
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <p class="text-md"><i class="fas fa-school"></i> <b>Thông tin trường:</b>
                </p>
            </div>
        </div>
        <div class="row row-cols-1 row-cols-sm-1 row-cols-md-5 row-cols-lg-5 row-cols-xl-5" v-if="modelRec">
            <div class="col">
                <p class="text-sm">Phân loại:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.tenPhanloaiTruongchuan
                        }}&nbsp;</b>
                </p>
            </div>
            <div class="col">
                <p class="text-sm">Mức trường chuẩn:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.tenMucTruongchuan }}&nbsp;</b>
                </p>

            </div>
            <div class="col">
                <p class="text-sm">Quy mô trường chuẩn:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.tenQuymoTruongchuan
                        }}&nbsp;</b>
                </p>
            </div>
            <div class="col">
                <p class="text-sm">Công lập:
                    <b v-if="modelRec.congLap == 1">&nbsp;&nbsp;&nbsp;Công
                        lập&nbsp;</b>
                    <b v-else-if="modelRec.congLap == 0">&nbsp;&nbsp;&nbsp;Tư
                        thục&nbsp;</b>
                    <b v-else>&nbsp;&nbsp;&nbsp;&nbsp;</b>
                </p>
            </div>
            <div class="col">
                <p class="text-sm">Vemis ID:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.vemisId }}&nbsp;</b>
                </p>
            </div>
        </div>
        <div class="row row-cols-1 row-cols-sm-1 row-cols-md-5 row-cols-lg-5 row-cols-xl-5" v-if="modelRec">
            <div class="col">
                <p class="text-sm">STT:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.stt }}&nbsp;</b>
                </p>
            </div>
            <div class="col">
                <p class="text-sm">ID:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.truongMamnonId
                        }}&nbsp;</b>
                </p>
            </div>
            <div class="col">
                <p class="text-sm">Trường ID:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.truongId }}&nbsp;</b>
                </p>
            </div>

            <div class="col">
                <p class="text-sm">Năm thành lập:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.namThanhLap }}&nbsp;</b>
                </p>
            </div>
            <div class="col">
                <p class="text-sm">Năm công nhận:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.namCongNhan }}&nbsp;</b>
                </p>
            </div>

        </div>
        <div class="row row-cols-1 row-cols-sm-1 row-cols-md-5 row-cols-lg-5 row-cols-xl-5" v-if="modelRec">
            <div class="col-12 col-md-3 col-lg-3 order-1 order-md-2">
                <p class="text-sm">Thông tin Hiệu trưởng:
                    <span class="d-block">&nbsp;&nbsp;&nbsp;- Họ tên: <b>{{ modelRec.hieuTruong }}</b> &nbsp;</span>
                    <span class="d-block">&nbsp;&nbsp;&nbsp;- SĐT: <b>{{ modelRec.sdtHieuTruong }}</b>&nbsp;</span>
                </p>
            </div>

            <div v-if="modelRec.namSatNhap" class="col-12 col-md-3 col-lg-3 order-1 order-md-2">
                <p class="text-sm">Năm sát nhập:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.namSatNhap }}&nbsp;</b>
                </p>
            </div>
            <div class="col-12 col-md-4 col-lg-4 order-1 order-md-2">
                <p class="text-sm">GPS:
                    <span class="d-block">&nbsp;&nbsp;&nbsp;- Long: <b>{{ modelRec.gpsLong }}</b> &nbsp;</span>
                    <span class="d-block">&nbsp;&nbsp;&nbsp;- Lat: <b>{{ modelRec.gpsLat }}</b>&nbsp;</span>
                </p>
            </div>
            <div class="col-12 col-md-4 col-lg-4 order-1 order-md-2">
                <p class="text-sm">Phường xã:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.tenPhuongXa }}&nbsp;</b>
                </p>
            </div>

            <div class="col-12 col-md-4 col-lg-4 order-1 order-md-2">
                <p class="text-sm">Hiển thị trên cổng:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.enabled ? "Có" : "Không"
                        }}&nbsp;</b>
                </p>
            </div>
        </div>

        <div class="row" v-if="modelRec && modelRec.ghiChu">
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <p class="text-sm">Ghi chú:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ghiChu }}&nbsp;</b>
                </p>
            </div>
        </div>
        <div class="row" v-if="modelRec">
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <p class="text-sm">Giới thiệu:
                    <span style="border: 1px solid rgba(0, 0, 0, .125); border-radius: 0.25rem; padding: 1em;"
                        class="d-block" id="gioiThieu_Detail"></span>
                </p>
            </div>
        </div>
        <div class="divider" v-if="modelRec && modelRec.tenKy"></div>
        <div class="row" v-if="modelRec && modelRec.tenKy">
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <p class="text-md"><i class="fas fa-calendar"></i>&nbsp;&nbsp;&nbsp;<b>Thông tin biến động:
                        <span style="color: #2489e3;">{{ modelRec.tenKy }}</span></b>
                </p>
            </div>
        </div>
        <div class="row" v-if="modelRec && modelRec.tenKy">
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin lớp:</b>
                </p>
            </div>
        </div>
        <div class="row row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4"
            v-if="modelRec && modelRec.tenKy">

            <div class="col" v-if="[1, 4, 3, 6].includes(parseInt(modelRec.phanloaiTruongMamnonId))">
                <p class="text-sm">Số nhóm trẻ:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.nhomTre }}&nbsp;</b>
                </p>
            </div>
            <div class="col" v-if="[2, 5, 3, 6].includes(parseInt(modelRec.phanloaiTruongMamnonId))">
                <p class="text-sm">Số lớp mẫu giáo:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.lopMauGiao }}&nbsp;</b>
                </p>
            </div>
        </div>
        <div class="row" v-if="modelRec && modelRec.tenKy">
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin phòng:</b>
                </p>
            </div>
        </div>
        <div class="row row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4"
            v-if="modelRec && modelRec.tenKy">
            <div class="col">
                <p class="text-sm">Tổng số phòng:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.tongsoPhong }}&nbsp;</b>
                </p>
            </div>
            <div class="col">
                <p class="text-sm">Số phòng kiên cố:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.phongKienco }}&nbsp;</b>
                </p>
            </div>
            <div class="col">
                <p class="text-sm">Số phòng bán kiên cố:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.phongBankienco }}&nbsp;</b>
                </p>
            </div>
            <div class="col">
                <p class="text-sm">Số phòng tạm:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.phongTam }}&nbsp;</b>
                </p>
            </div>
        </div>
        <div class="row" v-if="modelRec && modelRec.tenKy">
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin giáo viên:</b>
                </p>
            </div>
        </div>
        <div class="row row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4"
            v-if="modelRec && modelRec.tenKy">
            <div class="col">
                <p class="text-sm">Tổng số giáo viên:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.tongsoGiaovien }}&nbsp;</b>
                </p>
            </div>
            <div class="col">
                <p class="text-sm">Số giáo viên nữ:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.giaovienNu }}&nbsp;</b>
                </p>
            </div>
            <div class="col">
                <p class="text-sm">Số giáo viên dân tộc thiểu số:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.giaovienDantocThieuso }}&nbsp;</b>
                </p>
            </div>
            <div class="col">
                <p class="text-sm">Số giáo viên đạt chuẩn:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.giaovienDatchuan }}&nbsp;</b>
                </p>
            </div>
        </div>

        <div class="row" v-if="modelRec && modelRec.tenKy">
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin học sinh:</b>
                </p>
            </div>
        </div>
        <div class="row row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4"
            v-if="modelRec && modelRec.tenKy">
            <div class="col">
                <p class="text-sm">Tổng số học sinh:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.tongsoHocsinh }}&nbsp;</b>
                </p>
            </div>
            <div class="col">
                <p class="text-sm">Tổng số học sinh đã định danh:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.tongsoHocsinhDadinhdanh }}&nbsp;</b>
                </p>
            </div>
            <div class="col">
                <p class="text-sm">Số học sinh nữ:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.hocsinhNu }}&nbsp;</b>
                </p>
            </div>
            <div class="col">
                <p class="text-sm">Số học sinh dân tộc thiểu số:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.hocsinhDantocThieuso }}&nbsp;</b>
                </p>
            </div>
            <div class="col">
                <p class="text-sm">Số học sinh khuyết tật:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.hocsinhKhuyettat }}&nbsp;</b>
                </p>
            </div>
            <div class="col">
                <p class="text-sm">Số HS suy dinh dưỡng:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.hocsinhSuydinhduong }}&nbsp;</b>
                </p>
            </div>

            <div class="col" v-if="[1, 3, 4, 6].includes(parseInt(modelRec.phanloaiTruongMamnonId))">
                <p class="text-sm">Số HS 3 đến 12 tháng:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.hocsinh3den12M }}&nbsp;</b>
                </p>
            </div>
            <div class="col" v-if="[1, 3, 4, 6].includes(parseInt(modelRec.phanloaiTruongMamnonId))">
                <p class="text-sm">Số HS 13 đến 24 tháng:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.hocsinh13den24M }}&nbsp;</b>
                </p>
            </div>
            <div class="col" v-if="[1, 3, 4, 6].includes(parseInt(modelRec.phanloaiTruongMamnonId))">
                <p class="text-sm">Số HS 25 đến 36 tháng:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.hocsinh25den36M }}&nbsp;</b>
                </p>
            </div>



            <div class="col" v-if="[2, 3, 5, 6].includes(parseInt(modelRec.phanloaiTruongMamnonId))">
                <p class="text-sm">Số HS 3 đến 4 tuổi:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.hocsinh3den4Y }}&nbsp;</b>
                </p>
            </div>

            <div class="col" v-if="[2, 3, 5, 6].includes(parseInt(modelRec.phanloaiTruongMamnonId))">
                <p class="text-sm">Số HS 4 đến 5 tuổi:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.hocsinh4den5Y }}&nbsp;</b>
                </p>
            </div>

            <div class="col" v-if="[2, 3, 5, 6].includes(parseInt(modelRec.phanloaiTruongMamnonId))">
                <p class="text-sm">Số HS 5 đến 6 tuổi:
                    <b>&nbsp;&nbsp;&nbsp;{{ modelRec.hocsinh5den6Y }}&nbsp;</b>
                </p>
            </div>
        </div>
        <div class="divider" v-if="modelRec && modelRec.tenKy"></div>
        <div class="row" v-if="modelRec">
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <p class="text-md"><i class="nav-icon fas fa-images"></i>&nbsp;&nbsp;&nbsp;<b>Hình ảnh đính kèm:</b>
                </p>
            </div>
        </div>
        <div  v-if="modelRec" class="row row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
            <div class="col pl-3">
                <div class="">
                    <TheImageListPicker title="Ảnh hiệu trưởng" error=""
                        :initialValue="listFilesUpload.imageHieuTruongUpload" :isReadOnly="true" :isRequire="false"
                        :isMultiple="false" :key="tempKey" />
                </div>
            </div>
            <div class="col pl-3">
                <div class="">
                    <TheImageListPicker title="Ảnh tập thể" error="" :initialValue="listFilesUpload.imageTapTheUpload"
                        :isReadOnly="true" :isRequire="false" :isMultiple="false" :key="tempKey" />
                </div>
            </div>
            <div class="col pl-3">
                <div class="">
                    <TheImageListPicker title="Ảnh cổng trường" error=""
                        :initialValue="listFilesUpload.imageCongTruongUpload" :isReadOnly="true" :isRequire="false"
                        :isMultiple="false" :key="tempKey" />
                </div>
            </div>
            <div class="col pl-3">
                <div class="">
                    <TheImageListPicker title="Ảnh hoạt động" error=""
                        :initialValue="listFilesUpload.imageHoatDongUpload" :isReadOnly="true" :isRequire="false"
                        :isMultiple="false" :key="tempKey" />
                </div>
            </div>
        </div>

    </TheDetailFrameModal>
    <div class="modal fade" id="confirmcsListModal" data-keyboard="false" data-backdrop="static">
        <TheConfirmDialog :title="csList_MapModel.title" :confirmLabelButton="csList_MapModel.confirmLabelButton"
            :onClose="csList_MapModel.onClose" :onSubmit="csList_MapModel.onSubmit"
            :modalContent=csList_MapModel.modalContent></TheConfirmDialog>
    </div>

    <div class="modal fade" id="enabledConfirmModal" data-keyboard="false" data-backdrop="static">
        <TheCheckboxConfirmDialog :title="csListEnabled_MapModel.title"
            :confirmLabelButton="csListEnabled_MapModel.confirmLabelButton" :onClose="csListEnabled_MapModel.onClose"
            :onSubmit="csListEnabled_MapModel.onSubmit" :modalContent=csListEnabled_MapModel.modalContent
            v-model="checkEnable_Memo" :key="tempKey" :submitArgs="csListEnabled_MapModel.submitArgs">
        </TheCheckboxConfirmDialog>
    </div>

</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import objectDefaultValue from '@/config/object.env'
import tableValue from '@/config/table.env'
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import { read, utils, writeFileXLSX } from 'xlsx';
import axios from 'axios';
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';
import TheSelect2 from '@/components/shareComponents/TheSelect2.vue';
import TheYearPicker from '@/components/shareComponents/TheYearPicker.vue';
import TheConfirmDialog from '@/components/shareComponents/TheConfirmDialog.vue'
import TheCheckboxConfirmDialog from '@/components/shareComponents/TheCheckboxConfirmDialog.vue'
import TheGetLocationButton from '@/components/shareComponents/map/TheGetLocationButton.vue'
import TheImageListPicker from '@/components/shareComponents/TheImageListPicker.vue'

import { tableInteractiveModel } from '@/models/general/tableInteractive.model'
import { truongMamNonGD_v2Model } from '@/models/giaoduc/mamnon/truongMamNonGD_v2.model'

import TheDetailFrameModal from '@/components/shareComponents/modal/TheDetailFrameModal.vue'
import TheCRUDFrameModal from '@/components/shareComponents/modal/TheCRUDFrameModal.vue'

export default {
    name: "TruongMamNon",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
        TheSelect2,
        TheYearPicker,

        TheConfirmDialog,
        TheCheckboxConfirmDialog,
        TheGetLocationButton,
        TheImageListPicker,
        TheDetailFrameModal,
        TheCRUDFrameModal,

    },

    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],
            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadOnly: null,

            acceptImageType: objectDefaultValue.ACCEPT_TYPE_IMG,

            modelRec: truongMamNonGD_v2Model.newModel(),
            model: truongMamNonGD_v2Model.newFEModel(),
            errors: truongMamNonGD_v2Model.errors(),
            modelSearch: truongMamNonGD_v2Model.newPagingSearchModel(),

            cEnable_Value: null,

            navigateCode: objectDefaultValue.NAVIGATECODE_VALUE,
            navigateList: objectDefaultValue.NAVIGATECODE_LIST,
            typeDataList: objectDefaultValue.TYPEDATA_LIST,

            csList_Code: null,
            checkEnable_Memo: false,
            sType_List: objectDefaultValue.TYPEDATA_LIST.CURRENT_LIST.id,

            csList_Navigate: tableInteractiveModel.newList_NavigateModel(),
            csList_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            csListEnabled_MapModel: tableInteractiveModel.newListEnabled_MapModel(),
            category_MUCTRUONGCHUANGD: [],
            category_QUYMOTRUONGCHUANGD: [],
            category_LOAIHINHTRUONGMAMNON: [],
            category_sPHANLOAITRUONGMAMNON: [],
            category_cPHANLOAITRUONGMAMNON: [],
            category_PHUONGXA: [],
            category_cKY: [],
            category_ENABLED: objectDefaultValue.ENABLED_SELECTION,

            filesUpload: [],
            newAddedImage: [],
            deletedListImage: [],
            tempKey: common.randomString(10),

            loadingSubmit: false,

            oldValueKy: null,

            listFilesUpload: {
                filesUpload: [],
                imageHieuTruongUpload: [],
                imageTapTheUpload: [],
                imageCongTruongUpload: [],
                imageHoatDongUpload: [],
            },
            listFileNameUpload: {
                nameFilesUpload: '',
                nameImageHieuTruongUpload: '',
                nameImageTapTheUpload: '',
                nameImageCongTruongUpload: '',
                nameImageHoatDongUpload: '',
            },

            isFluctuationsReadOnly: false,
            isChangedValueKy: false,
        }
    },

    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('validate', ['validateRequired', 'validateNumber'],),
        ...mapActions('handleData2', ['handleTypeImport', 'handleChangeType', 'formatData']),
        ...mapActions('truongMamNonGD', ['getPagingTruongMamNonGD', 'getDetailTruongMamNonGD', 'checkExistTruongMamNonGD', 'createTruongMamNonGD', 'updateTruongMamNonGD', 'deleteTruongMamNonGD', 'restoreTruongMamNonGD', 'handleListTruongMamNonGD', 'setEnabledTruongMamNonGD', 'setEnabledIOCTruongMamNonGD', 'exportExcelTruongMamNonGD', 'getMapInfoTruongMamNonGD', 'importExcelTruongMamNonGD']),
        ...mapActions('truongMamNonGD_v2', ['createTruongMamNonGD2', 'updateTruongMamNonGD2', 'deleteTruongMamNonGD2', 'getCustomDetailTruongMamNonGD2', 'handleListTruongMamNonGD2', 'getCustomDetailwIdKyTruongMamNonGD2']),

        ...mapActions('mucTruongChuanGD', ['getBasicMucTruongChuanGD']),
        ...mapActions('quyMoTruongChuanGD', ['getBasicQuyMoTruongChuanGD']),
        ...mapActions('loaiHinhTruongMamNonGD', ['getBasicLoaiHinhTruongMamNonGD']),
        ...mapActions('phanLoaiTruongMamNonGD', ['getBasicPhanLoaiTruongMamNonGD']),
        ...mapActions('phuongXa', ['getsPhuongXa']),
        ...mapActions('dmKy', ['getBasicDMKy']),

        async setup() {
            let header = 'Danh sách Trường mầm non'
            this.setupHeader({ header })
        },

        async initialize() {
            this.category_MUCTRUONGCHUANGD = await this.getCategory_MucTruongChuanGD()
            this.category_QUYMOTRUONGCHUANGD = await this.getCategory_QuyMoTruongChuanGD()
            this.category_PHUONGXA = await this.getCategory_PhuongXa()
            this.category_LOAIHINHTRUONGMAMNON = await this.getCategory_LoaiHinhTruongMamNonGD()
        },


        //#region NavigateModal
        async showPopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('show')
        },
        async hidePopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('hide')
        },

        async openModal(modalRef) {
            this.$nextTick(() => {
                if (modalRef && typeof modalRef.showModal === 'function') {
                    modalRef.showModal();
                }
            });
        },

        async closeModal(modalRef) {
            this.$nextTick(() => {
                if (modalRef && typeof modalRef.closeModal === 'function') {
                    modalRef.closeModal();
                }
            });
        },

        async showEnabledConfirmModal() {
            this.csListEnabled_MapModel = {
                title: "XÁC NHẬN",
                confirmLabelButton: "Xác nhận",
                onClose: this.closeConfirmEnabledChange,
                onSubmit: this.updateEnabled,
                submitArgs: [2],
                modalContent: "<label>Bạn có chắc chắn muốn thay đổi hiển thị trên cổng?</label>",
            }
            this.tempKey = common.randomString(10)
            $('#enabledConfirmModal').modal('show')
        },
        async hideEnabledConfirmModal() {
            $('#enabledConfirmModal').modal('hide')
        },

        //#endregion NavigateModal

        //#region NavigateInTable
        async openConfirmEnabledChange(item) {
            if (!this.checkEnable_Memo) {
                this.cEnable_Value = item
                await this.showEnabledConfirmModal()
            }
            else {
                this.cEnable_Value = item
                this.updateEnabled(1)

            }
        },

        async updateEnabled(from) {
            let model = {
                truongMamnonId: this.cEnable_Value.truongMamnonId,
                enabled: from == 1 ? !this.cEnable_Value.enabledDisplay : this.cEnable_Value.enabledDisplay
            }
            await this.setEnabledTruongMamNonGD({ model: model }).then(resp => {
                if (resp) {
                    this.hideEnabledConfirmModal()
                }
                else {
                    this.hideEnabledConfirmModal()
                }
            });
        },

        async closeConfirmEnabledChange() {
            this.cEnable_Value.enabledDisplay = !this.cEnable_Value.enabledDisplay
            $('#item' + this.cEnable_Value.truongMamnonId).prop('checked', this.cEnable_Value.enabledDisplay);
            await this.hideEnabledConfirmModal()
        },

        // async closeConfirmIOCEnabledChange() {
        //     this.cEnable_Value.iocEnabledDisplay = !this.cEnable_Value.iocEnabledDisplay
        //     $('#itemIOC' + this.cEnable_Value.truongMamnonId).prop('checked', this.cEnable_Value.iocEnabledDisplay);
        //     await this.hideIOCEnabledConfirmModal()
        // },
        async navigateCheckBoxAll() {
            if (this.items.length != 0 && this.items.length == this.csList_Navigate.csList.length) {
                document.getElementById("checkboxAll").checked = true;
            }
            else {
                document.getElementById("checkboxAll").checked = false;
            }
        },

        async selectRow(id) {
            if (this.csList_Navigate.csList.includes(id)) {
                this.csList_Navigate.csList.splice(this.csList_Navigate.csList.indexOf(id), 1)
            }
            else {
                this.csList_Navigate.csList.push(id)
            }
            await this.navigateCheckBoxAll()
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.csList_Navigate.csList = this.items.map((item) => {
                    return item.truongMamnonId
                })
            }
            else {
                this.csList_Navigate.csList = []
            }
        },
        //#endregion NavigateInTable

        //#region NavigateSearch
        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.modelSearch.sort = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
            await this.navigateCheckBoxAll()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },

        async changeCurrentTypeSearch() {
            if (this.sType_List == this.typeDataList.DELETED_LIST.id) this.sType_List = this.typeDataList.CURRENT_LIST.id
            else if (this.sType_List == this.typeDataList.CURRENT_LIST.id) this.sType_List = this.typeDataList.DELETED_LIST.id
            await this.handlePageChange(1)
        },
        async onSelectSearchChange(e, typeChange) {
            if (typeChange == 'ENABLED') {
                switch (e) {
                    case "true":
                        this.modelSearch.enabled = true
                        break
                    case "false":
                        this.modelSearch.enabled = false
                        break
                    default:
                        this.modelSearch.enabled = null
                }
                this.handlePageChange(1)
                return
            }
            // if (typeChange == 'IOCENABLED') {
            //     switch (e) {
            //         case "true":
            //             this.modelSearch.truongId = true
            //             break
            //         case "false":
            //             this.modelSearch.truongId = false
            //             break
            //         default:
            //             this.modelSearch.truongId = null
            //     }
            //     this.handlePageChange(1)
            //     return
            // }
            if (typeChange == 'PHUONGXA') {
                this.modelSearch.phuongXaId = e == "" ? null : e
                this.handlePageChange(1)
                return
            }
            if (typeChange == 'MUCTRUONGCHUAN') {
                this.modelSearch.mucTruongchuanId = e == "" ? null : e
                this.handlePageChange(1)
                return
            }
            if (typeChange == 'QUYMOTRUONGCHUAN') {
                this.modelSearch.quymoTruongchuanId = e == "" ? null : e

                this.category_sPHANLOAITRUONGMAMNON = []
                this.modelSearch.phanloaiTruongMamnonId = null
                if (this.modelSearch.quymoTruongchuanId) {
                    this.category_sPHANLOAITRUONGMAMNON = await this.getCategory_PhanLoaiTruongMamNonGD(this.modelSearch.quymoTruongchuanId)
                }
                this.handlePageChange(1)
                return
            }
            if (typeChange == 'LOAIHINHTRUONG') {
                this.modelSearch.loaihinhTruongMamnonId = e == "" ? null : e
                this.handlePageChange(1)
                return
            }
            if (typeChange == 'PHANLOAITRUONG') {
                this.modelSearch.phanloaiTruongMamnonId = e == "" ? null : e
                this.handlePageChange(1)
                return
            }
        },
        async standardizationFilter() {
            this.modelSearch.pageNumber = this.pageNumber
            this.modelSearch.pageSize = this.pageSize
            if (this.modelSearch.tenTruong == "") this.modelSearch.tenTruong = null
            if (this.modelSearch.truongId == "") this.modelSearch.truongId = null
            if (this.modelSearch.vemisId == "") this.modelSearch.vemisId = null
        },

        async getData() {
            this.isBusy = true
            this.csList_Navigate.csList = []
            await this.standardizationFilter()

            await this.getPagingTruongMamNonGD({ params: this.modelSearch, type: this.sType_List }).then(res => {
                // List data
                this.items = res.data
                if (this.items) {
                    for (let i = 0; i < this.items.length; i++) {
                        this.items[i].enabledDisplay = this.items[i].enabled == 1 ? true : false
                        this.items[i].iocEnabledDisplay = this.items[i].iocEnabled == 1 ? true : false
                    }
                }

                // // Total row
                this.totalRow = res.totalRow
                // // Number show
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                // // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },

        //#endregion NavigateSearch

        //#region NavigateMap
        async openMap() {
            let params = {
            }
            let res = await this.getMapInfoTruongMamNonGD({ params: params })
            if (res) {
                let tableID = res[0].tableId ? res[0].tableId : null
                let loaiDiadiemId = (res[0].loaiDiadiemId != undefined) ? res[0].loaiDiadiemId.toString() : null
                let phanloaiDiadiemId = (res[0].phanloaiDiadiemId != undefined) ? res[0].phanloaiDiadiemId.toString() : null
                if (tableID || loaiDiadiemId || phanloaiDiadiemId) {
                    let link = config.QUYHOACH_PAGE + "AppCongDan/MapTienIch?"
                    link = tableID ? link + "tableId=" + tableID : link
                    link = loaiDiadiemId ? link + "&loaiDiadiemId=" + loaiDiadiemId : link
                    link = phanloaiDiadiemId ? link + "&phanloaiDiadiemId=" + phanloaiDiadiemId : link
                    window.open(link, "_blank");
                }
                else {
                    this.$store.dispatch("alert/error", "Lấy thông tin bản đồ thất bại!", { root: true });
                }

            }
        },

        async openDetailMap(detailID) {
            let params = {
            }
            let res = await this.getMapInfoTruongMamNonGD({ params: params })
            if (res) {
                let tableID = res[0].tableId ? res[0].tableId : null
                let loaiDiadiemId = (res[0].loaiDiadiemId != undefined) ? res[0].loaiDiadiemId.toString() : null
                let phanloaiDiadiemId = (res[0].phanloaiDiadiemId != undefined) ? res[0].phanloaiDiadiemId.toString() : null
                if (tableID || loaiDiadiemId || phanloaiDiadiemId) {
                    let link = config.QUYHOACH_PAGE + "AppCongDan/MapTienIch?"
                    link = tableID ? link + "tableId=" + tableID : link
                    link = loaiDiadiemId ? link + "&loaiDiadiemId=" + loaiDiadiemId : link
                    link = phanloaiDiadiemId ? link + "&phanloaiDiadiemId=" + phanloaiDiadiemId : link
                    link = detailID ? link + "&detailId=" + detailID : link
                    window.open(link, "_blank");
                }
                else {
                    this.$store.dispatch("alert/error", "Lấy thông tin bản đồ thất bại!", { root: true });
                }
            }
        },
        //#endregion NavigateMap

        //#region CUD
        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            this.styleButton = this.$t('style.styleButton' + code)
            this.styleTitle = this.$t('style.styleTitle' + code)
            this.category_cKY = await this.getCategory_Ky()
            this.errors = truongMamNonGD_v2Model.errors()

            this.oldValueKy = null;

            if (this.code == this.navigateCode.UPDATE || this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) {
                let params = {
                    truongMamnonId: item.truongMamnonId
                }
                let resp = await this.getCustomDetailTruongMamNonGD2({ params }).then(async resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        // Ham Custom API
                        this.modelRec = truongMamNonGD_v2Model.newModel()
                        this.modelRec = resp
                        this.model = truongMamNonGD_v2Model.parseModeltoFEModel(this.modelRec.detailInfo)
                        if (this.model.quymoTruongchuanId) {
                            this.category_cPHANLOAITRUONGMAMNON = await this.getCategory_PhanLoaiTruongMamNonGD(this.model.quymoTruongchuanId)
                        }
                        this.oldValueKy = this.modelRec.detailInfo?.tenKy
                        if(this.oldValueKy) this.isFluctuationsReadOnly = this.category_cKY.some(item => item.id === this.model.idKy) ? false : true

                        //Modify Image Data
                        let fHinhAnh = [{
                            fileId: this.modelRec.detailInfo.hinhAnh,
                            fileName: this.modelRec.detailInfo.tenFileHinhAnh,
                            downloadLink: this.modelRec.detailInfo.linkHinhAnh,
                        }]
                        this.listFileNameUpload.nameFilesUpload = this.modelRec.detailInfo.tenFileHinhAnh
                        this.listFilesUpload.filesUpload = this.modelRec.detailInfo.hinhAnh ? JSON.parse(JSON.stringify(fHinhAnh)) : [];
                        if (this.modelRec.fileHinhAnhInfo) {
                            let temp = this.modelRec.fileHinhAnhInfo.filter(e => e.idChudeMedia == 2)[0] ? this.modelRec.fileHinhAnhInfo.filter(e => e.idChudeMedia == 2)[0] : null
                            this.listFileNameUpload.nameImageHieuTruongUpload = temp ? temp.tenFileHinhAnh : null
                            this.listFilesUpload.imageHieuTruongUpload = temp ?
                                JSON.parse(JSON.stringify([{
                                    fileId: temp.idHinhAnh,
                                    fileName: temp.tenFileHinhAnh,
                                    downloadLink: temp.linkHinhAnh,
                                }]))
                                : []



                            temp = this.modelRec.fileHinhAnhInfo.filter(e => e.idChudeMedia == 3)[0] ? this.modelRec.fileHinhAnhInfo.filter(e => e.idChudeMedia == 3)[0] : null
                            this.listFileNameUpload.nameImageTapTheUpload = temp ? temp.tenFileHinhAnh : null
                            this.listFilesUpload.imageTapTheUpload = temp ?
                                JSON.parse(JSON.stringify([{
                                    fileId: temp.idHinhAnh,
                                    fileName: temp.tenFileHinhAnh,
                                    downloadLink: temp.linkHinhAnh,
                                }]))
                                : []


                            temp = this.modelRec.fileHinhAnhInfo.filter(e => e.idChudeMedia == 4)[0] ? this.modelRec.fileHinhAnhInfo.filter(e => e.idChudeMedia == 4)[0] : null
                            this.listFileNameUpload.nameImageCongTruongUpload = temp ? temp.tenFileHinhAnh : null
                            this.listFilesUpload.imageCongTruongUpload = temp ?
                                JSON.parse(JSON.stringify([{
                                    fileId: temp.idHinhAnh,
                                    fileName: temp.tenFileHinhAnh,
                                    downloadLink: temp.linkHinhAnh,
                                }]))
                                : []

                            temp = this.modelRec.fileHinhAnhInfo.filter(e => e.idChudeMedia == 5)[0] ? this.modelRec.fileHinhAnhInfo.filter(e => e.idChudeMedia == 5)[0] : null
                            this.listFileNameUpload.nameImageHoatDongUpload = temp ? temp.tenFileHinhAnh : null
                            this.listFilesUpload.imageHoatDongUpload = temp ?
                                JSON.parse(JSON.stringify([{
                                    fileId: temp.idHinhAnh,
                                    fileName: temp.tenFileHinhAnh,
                                    downloadLink: temp.linkHinhAnh,
                                }]))
                                : []
                        }
                    }
                });
                this.isReadOnly = (this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) ? true : false
                if(this.isFluctuationsReadOnly == false) this.isFluctuationsReadOnly = this.isReadOnly
                this.loadingSubmit = false
                this.tempKey = common.randomString(10)
                await this.openModal(this.$refs.modalCRUDRef)

            }
            else if (this.code == this.navigateCode.DETAIL) {
                let params = {
                    truongMamnonId: item.truongMamnonId
                }
                await this.getCustomDetailTruongMamNonGD2({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = truongMamNonGD_v2Model.newModel()
                        this.modelRec = resp.detailInfo
                        if (this.modelRec.gioiThieu) {
                            let contentDiv = document.getElementById('gioiThieu_Detail');
                            contentDiv.innerHTML = this.modelRec.gioiThieu;
                        }
                        else {
                            let contentDiv = document.getElementById('gioiThieu_Detail');
                            contentDiv.innerHTML = '';
                        }

                        if (resp.fileHinhAnhInfo) {
                            let temp = resp.fileHinhAnhInfo.filter(e => e.idChudeMedia == 2)[0] ? resp.fileHinhAnhInfo.filter(e => e.idChudeMedia == 2)[0] : null
                            this.listFileNameUpload.nameImageHieuTruongUpload = temp ? temp.tenFileHinhAnh : null
                            this.listFilesUpload.imageHieuTruongUpload = temp ?
                                JSON.parse(JSON.stringify([{
                                    fileId: temp.idHinhAnh,
                                    fileName: temp.tenFileHinhAnh,
                                    downloadLink: temp.linkHinhAnh,
                                }]))
                                : []



                            temp = resp.fileHinhAnhInfo.filter(e => e.idChudeMedia == 3)[0] ? resp.fileHinhAnhInfo.filter(e => e.idChudeMedia == 3)[0] : null
                            this.listFileNameUpload.nameImageTapTheUpload = temp ? temp.tenFileHinhAnh : null
                            this.listFilesUpload.imageTapTheUpload = temp ?
                                JSON.parse(JSON.stringify([{
                                    fileId: temp.idHinhAnh,
                                    fileName: temp.tenFileHinhAnh,
                                    downloadLink: temp.linkHinhAnh,
                                }]))
                                : []


                            temp = resp.fileHinhAnhInfo.filter(e => e.idChudeMedia == 4)[0] ? resp.fileHinhAnhInfo.filter(e => e.idChudeMedia == 4)[0] : null
                            this.listFileNameUpload.nameImageCongTruongUpload = temp ? temp.tenFileHinhAnh : null
                            this.listFilesUpload.imageCongTruongUpload = temp ?
                                JSON.parse(JSON.stringify([{
                                    fileId: temp.idHinhAnh,
                                    fileName: temp.tenFileHinhAnh,
                                    downloadLink: temp.linkHinhAnh,
                                }]))
                                : []

                            temp = resp.fileHinhAnhInfo.filter(e => e.idChudeMedia == 5)[0] ? resp.fileHinhAnhInfo.filter(e => e.idChudeMedia == 5)[0] : null
                            this.listFileNameUpload.nameImageHoatDongUpload = temp ? temp.tenFileHinhAnh : null
                            this.listFilesUpload.imageHoatDongUpload = temp ?
                                JSON.parse(JSON.stringify([{
                                    fileId: temp.idHinhAnh,
                                    fileName: temp.tenFileHinhAnh,
                                    downloadLink: temp.linkHinhAnh,
                                }]))
                                : []
                        }
                    }
                });
                this.tempKey = common.randomString(10)
                this.openModal(this.$refs.modalDetailRef)
            }
            else {
                this.loadingSubmit = false
                this.model = truongMamNonGD_v2Model.newFEModel()
                await this.setNullListHinhAnh()
                this.listFileNameUpload.filesUpload = []
                this.newAddedImage = []
                this.deletedListImage = []
                this.isReadOnly = this.isFluctuationsReadOnly = (code == this.navigateCode.CREATE) ? false : true
                this.model.enabledDisplay = true
                this.model.stt = "0"
                $(".onSelectNam").val(null).trigger('change')
                // show popup
                this.tempKey = common.randomString(10)
                this.openModal(this.$refs.modalCRUDRef)
            }
        },

        async setNullListHinhAnh() {
            this.listFilesUpload = {
                filesUpload: [],
                imageHieuTruongUpload: [],
                imageTapTheUpload: [],
                imageCongTruongUpload: [],
                imageHoatDongUpload: [],
            }
        },

        async checkExistName(name) {
            let params = {
                tenTruong: name
            }
            let res = await this.checkExistTruongMamNonGD({ params: params })
            return res.data

        },
        async validate(model) {
            let isvalid = true
            this.errors = truongMamNonGD_v2Model.errors()
            if (!await this.validateRequired(model.tenTruong)) {
                this.errors.tenTruong = "Nhập tên"
                isvalid = false
            }
            else if (this.code == this.navigateCode.UPDATE && this.modelRec.detailInfo.tenTruong != model.tenTruong) {
                if (await this.checkExistName(model.tenTruong)) {
                    this.errors.tenTruong = "Tên này đã tồn tại trên hệ thống"
                    isvalid = false
                }
            }
            else if (this.code == this.navigateCode.CREATE) {
                if (await this.checkExistName(model.tenTruong)) {
                    this.errors.tenTruong = "Tên này đã tồn tại trên hệ thống"
                    isvalid = false
                }
            }
            if (!await this.validateRequired(model.stt)) {
                this.errors.stt = "Nhập số thứ tự"
                isvalid = false
            }
            else if (!await this.validateNumber(model.stt)) {
                this.errors.stt = "Số thứ tự phải là kiểu số"
                isvalid = false
            }

            if (!await this.validateRequired(model.mucTruongchuanId)) {
                this.errors.mucTruongchuanId = "Chọn mức trường chuẩn"
                isvalid = false
            }

            if (!await this.validateRequired(model.quymoTruongchuanId)) {
                this.errors.quymoTruongchuanId = "Chọn quy mô trường chuẩn"
                isvalid = false
            }

            if (!await this.validateRequired(model.loaihinhTruongMamnonId)) {
                this.errors.loaihinhTruongMamnonId = "Chọn loại hình trường"
                isvalid = false
            }
            if (!await this.validateRequired(model.phanloaiTruongMamnonId)) {
                this.errors.phanloaiTruongMamnonId = "Chọn phân loại trường"
                isvalid = false
            }
            if (!await this.validateRequired(model.phuongXaId)) {
                this.errors.phuongXaId = "Chọn phường xã"
                isvalid = false
            }

            return isvalid
        },
        async modifySendModel(FEmodel) {
            let sendModel = truongMamNonGD_v2Model.newModel()
            if (this.code == this.navigateCode.DELETE
                || this.code == this.navigateCode.RESTORE
                || this.code == this.navigateCode.DELETE_TEMP) sendModel.truongMamnonId = FEmodel.truongMamnonId
            else {
                if (this.code == this.navigateCode.UPDATE) sendModel.truongMamnonId = FEmodel.truongMamnonId
                sendModel.tenTruong = FEmodel.tenTruong
                sendModel.truongId = FEmodel.truongId == "" ? null : FEmodel.truongId
                sendModel.hieuTruong = FEmodel.hieuTruong
                sendModel.sdtHieuTruong = FEmodel.sdtHieuTruong
                sendModel.mucTruongchuanId = FEmodel.mucTruongchuanId == "" ? null : FEmodel.mucTruongchuanId
                sendModel.namCongNhan = FEmodel.namCongNhan
                sendModel.quymoTruongchuanId = FEmodel.quymoTruongchuanId == "" ? null : FEmodel.quymoTruongchuanId
                sendModel.namSatNhap = FEmodel.namSatNhap
                sendModel.vemisId = FEmodel.vemisId == "" ? null : FEmodel.vemisId
                sendModel.namThanhLap = FEmodel.namThanhLap
                sendModel.gpsLong = FEmodel.gpsLong
                sendModel.gpsLat = FEmodel.gpsLat
                sendModel.loaihinhTruongMamnonId = FEmodel.loaihinhTruongMamnonId
                sendModel.phanloaiTruongMamnonId = FEmodel.phanloaiTruongMamnonId
                sendModel.phuongXaId = FEmodel.phuongXaId
                sendModel.gioiThieu = FEmodel.gioiThieu

                sendModel.idKy = FEmodel.idKy ? FEmodel.idKy : null

                sendModel.tongsoGiaovien = (!FEmodel.tongsoGiaovien || FEmodel.tongsoGiaovien == "") ? 0 : FEmodel.tongsoGiaovien
                sendModel.giaovienNu = (!FEmodel.giaovienNu || FEmodel.giaovienNu == "") ? 0 : FEmodel.giaovienNu
                sendModel.giaovienDantocThieuso = (!FEmodel.giaovienDantocThieuso || FEmodel.giaovienDantocThieuso == "") ? 0 : FEmodel.giaovienDantocThieuso
                sendModel.giaovienDatchuan = (!FEmodel.giaovienDatchuan || FEmodel.giaovienDatchuan == "") ? 0 : FEmodel.giaovienDatchuan

                sendModel.tongsoHocsinh = (!FEmodel.tongsoHocsinh || FEmodel.tongsoHocsinh == "") ? 0 : FEmodel.tongsoHocsinh
                sendModel.tongsoHocsinhDadinhdanh = (!FEmodel.tongsoHocsinhDadinhdanh || FEmodel.tongsoHocsinhDadinhdanh == "") ? 0 : FEmodel.tongsoHocsinhDadinhdanh
                sendModel.hocsinhNu = (!FEmodel.hocsinhNu || FEmodel.hocsinhNu == "") ? 0 : FEmodel.hocsinhNu
                sendModel.hocsinhDantocThieuso = (!FEmodel.hocsinhDantocThieuso || FEmodel.hocsinhDantocThieuso == "") ? 0 : FEmodel.hocsinhDantocThieuso
                sendModel.hocsinhKhuyettat = (!FEmodel.hocsinhKhuyettat || FEmodel.hocsinhKhuyettat == "") ? 0 : FEmodel.hocsinhKhuyettat
                sendModel.hocsinhSuydinhduong = (!FEmodel.hocsinhSuydinhduong || FEmodel.hocsinhSuydinhduong == "") ? 0 : FEmodel.hocsinhSuydinhduong

                if (this.model.phanloaiTruongMamnonId == 1) {
                    sendModel.hocsinh3den12M = await this.handleChangeType({ input: FEmodel.hocsinh3den12M, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh13den24M = await this.handleChangeType({ input: FEmodel.hocsinh13den24M, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh25den36M = await this.handleChangeType({ input: FEmodel.hocsinh25den36M, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh3den4Y = 0
                    sendModel.hocsinh4den5Y = 0
                    sendModel.hocsinh5den6Y = 0

                    sendModel.nhomTre = await this.handleChangeType({ input: FEmodel.nhomTre, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.lopMauGiao = 0

                }
                else if (this.model.phanloaiTruongMamnonId == 2) {
                    sendModel.hocsinh3den12M = 0
                    sendModel.hocsinh13den24M = 0
                    sendModel.hocsinh25den36M = 0
                    sendModel.hocsinh3den4Y = await this.handleChangeType({ input: FEmodel.hocsinh3den4Y, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh4den5Y = await this.handleChangeType({ input: FEmodel.hocsinh4den5Y, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh5den6Y = await this.handleChangeType({ input: FEmodel.hocsinh5den6Y, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })

                    sendModel.lopMauGiao = await this.handleChangeType({ input: FEmodel.lopMauGiao, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.nhomTre = 0
                }
                else if (this.model.phanloaiTruongMamnonId == 3) {
                    sendModel.hocsinh3den12M = await this.handleChangeType({ input: FEmodel.hocsinh3den12M, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh13den24M = await this.handleChangeType({ input: FEmodel.hocsinh13den24M, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh25den36M = await this.handleChangeType({ input: FEmodel.hocsinh25den36M, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh3den4Y = await this.handleChangeType({ input: FEmodel.hocsinh3den4Y, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh4den5Y = await this.handleChangeType({ input: FEmodel.hocsinh4den5Y, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh5den6Y = await this.handleChangeType({ input: FEmodel.hocsinh5den6Y, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })

                    sendModel.lopMauGiao = await this.handleChangeType({ input: FEmodel.lopMauGiao, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.nhomTre = await this.handleChangeType({ input: FEmodel.nhomTre, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })

                }
                else if (this.model.phanloaiTruongMamnonId == 4) {
                    sendModel.hocsinh3den12M = await this.handleChangeType({ input: FEmodel.hocsinh3den12M, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh13den24M = await this.handleChangeType({ input: FEmodel.hocsinh13den24M, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh25den36M = await this.handleChangeType({ input: FEmodel.hocsinh25den36M, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh3den4Y = 0
                    sendModel.hocsinh4den5Y = 0
                    sendModel.hocsinh5den6Y = 0

                    sendModel.nhomTre = await this.handleChangeType({ input: FEmodel.nhomTre, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.lopMauGiao = 0
                }
                else if (this.model.phanloaiTruongMamnonId == 5) {
                    sendModel.hocsinh3den12M = 0
                    sendModel.hocsinh13den24M = 0
                    sendModel.hocsinh25den36M = 0
                    sendModel.hocsinh3den4Y = await this.handleChangeType({ input: FEmodel.hocsinh3den4Y, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh4den5Y = await this.handleChangeType({ input: FEmodel.hocsinh4den5Y, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh5den6Y = await this.handleChangeType({ input: FEmodel.hocsinh5den6Y, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })

                    sendModel.lopMauGiao = await this.handleChangeType({ input: FEmodel.lopMauGiao, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.nhomTre = 0

                }
                else if (this.model.phanloaiTruongMamnonId == 6) {
                    sendModel.hocsinh3den12M = await this.handleChangeType({ input: FEmodel.hocsinh3den12M, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh13den24M = await this.handleChangeType({ input: FEmodel.hocsinh13den24M, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh25den36M = await this.handleChangeType({ input: FEmodel.hocsinh25den36M, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh3den4Y = await this.handleChangeType({ input: FEmodel.hocsinh3den4Y, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh4den5Y = await this.handleChangeType({ input: FEmodel.hocsinh4den5Y, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.hocsinh5den6Y = await this.handleChangeType({ input: FEmodel.hocsinh5den6Y, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })

                    sendModel.lopMauGiao = await this.handleChangeType({ input: FEmodel.lopMauGiao, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                    sendModel.nhomTre = await this.handleChangeType({ input: FEmodel.nhomTre, typeChange: objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED })
                }

                //Phòng học
                sendModel.tongsoPhong = (!FEmodel.tongsoPhong || FEmodel.tongsoPhong == "") ? 0 : FEmodel.tongsoPhong
                sendModel.phongKienco = (!FEmodel.phongKienco || FEmodel.phongKienco == "") ? 0 : FEmodel.phongKienco
                sendModel.phongBankienco = (!FEmodel.phongBankienco || FEmodel.phongBankienco == "") ? 0 : FEmodel.phongBankienco
                sendModel.phongTam = (!FEmodel.phongTam || FEmodel.phongTam == "") ? 0 : FEmodel.phongTam




                sendModel.ghiChu = FEmodel.ghiChu
                //sendModel.iocId = FEmodel.iocId
                sendModel.stt = FEmodel.stt
                sendModel.enabled = FEmodel.enabledDisplay ? FEmodel.enabledDisplay : false
                //sendModel.iocEnabled = FEmodel.iocEnabledDisplay ? FEmodel.iocEnabledDisplay : false

                let formatToSendHinhAnh = {
                    typeSend: this.code,
                    files: this.listFilesUpload.filesUpload,
                    nameOldFile: this.listFileNameUpload.nameFilesUpload,
                }
                await this.formatData({ input: formatToSendHinhAnh, typeFormat: 'aFileToSend' }).then(resp => {
                    if (resp) {
                        sendModel.fHinhAnh = resp.file
                        sendModel.xoaHinhAnh = resp.isDeleted
                    }
                })
                formatToSendHinhAnh = {
                    typeSend: this.code,
                    files: this.listFilesUpload.imageHieuTruongUpload,
                    nameOldFile: this.listFileNameUpload.nameImageHieuTruongUpload,
                }

                await this.formatData({ input: formatToSendHinhAnh, typeFormat: 'aFileToSend' }).then(resp => {
                    if (resp) {
                        sendModel.fHinhAnhHieuTruong = resp.file
                        sendModel.xoaHinhAnhHieuTruong = resp.isDeleted
                    }
                })

                formatToSendHinhAnh = {
                    typeSend: this.code,
                    files: this.listFilesUpload.imageTapTheUpload,
                    nameOldFile: this.listFileNameUpload.nameImageTapTheUpload,
                }
                await this.formatData({ input: formatToSendHinhAnh, typeFormat: 'aFileToSend' }).then(resp => {
                    if (resp) {
                        sendModel.fHinhAnhTapThe = resp.file
                        sendModel.xoaHinhAnhTapThe = resp.isDeleted
                    }
                })

                formatToSendHinhAnh = {
                    typeSend: this.code,
                    files: this.listFilesUpload.imageCongTruongUpload,
                    nameOldFile: this.listFileNameUpload.nameImageCongTruongUpload,
                }
                await this.formatData({ input: formatToSendHinhAnh, typeFormat: 'aFileToSend' }).then(resp => {
                    if (resp) {
                        sendModel.fHinhAnhCongTruong = resp.file
                        sendModel.xoaHinhAnhCongTruong = resp.isDeleted
                    }
                })

                formatToSendHinhAnh = {
                    typeSend: this.code,
                    files: this.listFilesUpload.imageHoatDongUpload,
                    nameOldFile: this.listFileNameUpload.nameImageHoatDongUpload,
                }
                await this.formatData({ input: formatToSendHinhAnh, typeFormat: 'aFileToSend' }).then(resp => {
                    if (resp) {
                        sendModel.fHinhAnhHoatDong = resp.file
                        sendModel.xoaHinhAnhHoatDong = resp.isDeleted
                    }
                })
            }
            return sendModel
        },

        async onChangeEdit_KY(v) {
            this.model.idKy = v
            this.isChangedValueKy = true
            this.isFluctuationsReadOnly = false
            if (this.code == this.navigateCode.UPDATE) {
                let params = {
                    truongMamnonId: this.model.truongMamnonId,
                    idKy: this.model.idKy
                }
                await this.getCustomDetailwIdKyTruongMamNonGD2({ params }).then(async resp => {
                    if (resp) {
                        this.model = truongMamNonGD_v2Model.reLoadDataFluctuations(this.model, resp?.detailInfo)
                        this.tempKey = common.randomString(10)
                    }
                })
            }
        },
        async onChangeEDIT_QuyMo(e) {
            this.model.quymoTruongchuanId = e == "" ? null : e
            this.category_cPHANLOAITRUONGMAMNON = []
            this.model.phanloaiTruongMamnonId = null
            if (this.model.quymoTruongchuanId) {
                this.category_cPHANLOAITRUONGMAMNON = await this.getCategory_PhanLoaiTruongMamNonGD(this.model.quymoTruongchuanId)
            }
            //this.tempKey = common.randomString(10)
        },

        async onSubmit() {
            let code = this.code
            this.loadingSubmit = true
            let sendModel = await this.modifySendModel(this.model)
            let res = false
            switch (code) {
                case this.navigateCode.CREATE:
                    if (await this.validate(sendModel)) {
                        res = await this.createTruongMamNonGD2({ model: sendModel })
                    }
                    break
                case this.navigateCode.UPDATE:
                    if (await this.validate(sendModel)) {
                        res = await this.updateTruongMamNonGD2({ model: sendModel })
                    }
                    break
                case this.navigateCode.DELETE_TEMP:
                    res = await this.deleteTruongMamNonGD({ model: sendModel, type: this.sType_List })
                    break
                case this.navigateCode.DELETE:
                    res = await this.deleteTruongMamNonGD2({ model: sendModel, type: this.sType_List })
                    break
                case this.navigateCode.RESTORE:
                    res = await this.restoreTruongMamNonGD({ model: sendModel })
                    break
                default:
            }
            if (res) {
                await this.getData()
                await this.closeModal(this.$refs.modalCRUDRef)
            }
            this.loadingSubmit = false
        },
        //#endregion CUD

        //#region NavigateMultipleInTable
        async confirmList(code) {
            if (this.csList_Navigate.csList.length == 0) {
                this.warning(this.$t('labels.selectItem'))
            }
            else {
                this.csList_Navigate.csList_Code = code
                let foundItem = this.navigateList.find(item => item.code === code);
                this.csList_Navigate.csList_Title = foundItem ? foundItem.title : ""

                this.csList_MapModel = {
                    title: this.csList_Navigate.csList_Title,
                    confirmLabelButton: this.csList_Navigate.csList_Title,
                    onClose: this.hidePopupconfirmcsListModal,
                    onSubmit: this.onSubmitList,
                    modalContent: "Bạn có chắc chắn <b>" + this.csList_Navigate.csList_Title + "</b> các dữ liệu đã chọn?",
                }
                this.showPopupconfirmcsListModal()
            }
        },
        async onSubmitList() {
            let code = this.csList_Navigate.csList_Code
            let modelSend = {
                model: {
                    listId: this.csList_Navigate.csList.toString()
                },
                type: code
            }
            if (code == this.navigateCode.OFF_ENABLED) {
                modelSend.model.enabled = false
            }
            if (code == this.navigateCode.ON_ENABLED) {
                modelSend.model.enabled = true
            }
            // if (code == this.navigateCode.ON_IOC_ENABLED) {
            //     modelSend.model.enabled = false
            // }
            // if (code == this.navigateCode.OFF_IOC_ENABLED) {
            //     modelSend.model.enabled = true
            // }
            let res = null
            if (code == objectDefaultValue.NAVIGATECODE_VALUE.DELETE) {
                res = await this.handleListTruongMamNonGD2(modelSend)
            }
            else {
                res = await this.handleListTruongMamNonGD(modelSend)
            }

            if (res) {
                await this.getData()
                await this.navigateCheckBoxAll()
                this.hidePopupconfirmcsListModal()
            }
        },
        //#endregion NavigateMultipleInTable

        //#region getCategory
        async getCategory_MucTruongChuanGD() {
            let params = {
            }
            let res = await this.getBasicMucTruongChuanGD({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].mucTruongchuanId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }

            return res
        },

        async getCategory_QuyMoTruongChuanGD() {
            let params = {
                tableId: 84
            }
            let res = await this.getBasicQuyMoTruongChuanGD({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].quymoTruongchuanId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }

            return res
        },


        async getCategory_LoaiHinhTruongMamNonGD() {
            let params = {
            }
            let res = await this.getBasicLoaiHinhTruongMamNonGD({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].loaihinhTruongMamnonId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }

            return res
        },

        async getCategory_PhanLoaiTruongMamNonGD(quymoTruongchuanId) {
            let params = {
                quymoTruongchuanId: quymoTruongchuanId
            }
            let res = await this.getBasicPhanLoaiTruongMamNonGD({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].phanloaiTruongMamnonId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }

            return res
        },

        async getCategory_PhuongXa() {
            let params = {
                quanHuyenId: config.QUANHUYEN_SITEID
            }
            let res = await this.getsPhuongXa({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].phuongXaId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }

            return res
        },

        async getCategory_Ky(filterNumber = 0) {
            let params = {
                tableName: tableValue.GD_TRUONGMAMNON_QGGD,
                loaiKy: 'YGD'
            }
            params.filter = filterNumber
            let res = await this.getBasicDMKy({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].idKy,
                            name: res[i].tenKy
                        }
                    )
                }
                return handleRes
            }

            return res
        },

        //#endregion getCategory

    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()
    }


}
</script>
<style>
/* Định dạng cho khung */
.modal-box {
    width: 100%;
    height: auto;
    border: 1px solid rgba(0, 0, 0, .125);
    border-radius: .25rem;
    position: relative;
    padding-top: 1.5rem;
    margin: 10px;
}

.header-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: -1rem;
    left: 1rem;
    right: 3rem;
}

.header-box.no-dropdown {
    justify-content: left;
}

.title-box {
    background-color: white;
    font-weight: bold;
    font-size: 1rem;
}

.title2-box {
    background-color: white;
    /* font-weight: bold; */
    font-size: 1rem;
}


.modal-box-content {
    padding: 0 1rem;
}

.divider {
    width: 100%;
    height: 1px;
    background-color: #333;
    margin: 1rem 0;
    /* Khoảng cách trên và dưới */
}


/* Đưa dropdown xuống hàng khi màn hình nhỏ hơn 480px */
@media (max-width: 480px) {
    .modal-box {
        width: 90%;
        padding-top: 3rem;
    }

    .header-box {
        flex-direction: column;
        align-items: flex-start;
        right: unset
            /* Căn trái */
    }

    .title-box {
        font-size: 1rem;
    }

    .title2-box {
        /* font-size: 0.9rem; */
        width: 100%;
        /* Để dropdown chiếm toàn bộ chiều rộng */
    }

    .modal-box-content {
        font-size: 0.9rem;
        padding-top: 1rem;
    }
}

.select2-container--bootstrap4 .select2-selection {
    min-width: 8rem;
    /* Đặt chiều rộng tối thiểu theo ý muốn */
}
</style>